import { Badge, BadgeSize, BadgeVariant } from "shared/components/Badge";
import type { Unit } from "types/landlord/address";
import { STATUS_BADGE } from "shared/app/AddressValidationStatus/statusBadge";

interface UnitAddressValidationCellProps {
  unit: Pick<Unit, "address" | "address_inherited_from_property">;
}

export const UnitAddressValidationCell = ({
  unit
}: UnitAddressValidationCellProps) => {
  if (unit.address_inherited_from_property)
    return (
      <Badge
        variant={BadgeVariant.BASE}
        size={BadgeSize.SM}
        tooltip="This unit has no address of its own, so the property's address is checked instead."
      >
        Uses property address
      </Badge>
    );

  const status = unit.address?.address_validation_status ?? "not_checked";
  const { variant, label } = STATUS_BADGE[status];
  const issue = unit.address?.address_validation_issue;

  return (
    <Badge
      variant={variant}
      size={BadgeSize.SM}
      className="shrink-0 whitespace-nowrap"
      tooltip={status === "issue_found" ? issue : undefined}
    >
      {label}
    </Badge>
  );
};
